 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		20: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		20: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"6e9765af0d8cadc878f9f8c2310a458594d6236c","1":"3535c12f2676d7d818bc3663a5d68b8cdaf57932","2":"de71a805","3":"1bfc9850","4":"e13c3f781831cf288a166224be59f9e900beb1eb","5":"7261c7a5008f72e8df93cca2226e5795336d06c6","6":"styles","7":"0b88e34b4cfcb3cef2b98900384b5bced6ad52cf","8":"c5dfd7d200e7f3593e8384acc111a781d580d7e0","9":"c21f3e3758b538213289b51509a631e3a51d21f3","10":"fadb1fcec6cad6cacf534cb5e8a7a44a2c4254a0","11":"5e2a4920","12":"a4c92b5b","13":"c12974d03ffdc601d101aab1c7f05ad2f6d58131","14":"e5a5014b076735dc5398446ae7003bffb5485bb0","15":"a48987767876a59d3057dc923b8b92fef19b97b4","16":"e2795cd79bdc65c94c741a4388b83e68c3033fab","17":"1b404b28ab79dc07c3b6f61c1d07ff237951e496","18":"1ca2f4d91de47e91be63b0c64ca93d14f0cceb14","19":"e52995f9af5ad4a238f3249a061497eb8d65e61e","22":"95b64a6e","24":"component---cache-caches-gatsby-plugin-offline-app-shell-js","25":"component---src-pages-404-js","26":"component---src-pages-about-us-js","27":"component---src-pages-analytics-js","28":"component---src-pages-blockchain-js","29":"component---src-pages-cloud-js","30":"component---src-pages-contact-us-js","31":"component---src-pages-digital-transformation-js","32":"component---src-pages-elements-accordion-js","33":"component---src-pages-elements-box-icon-js","34":"component---src-pages-elements-box-image-js","35":"component---src-pages-elements-box-large-image-js","36":"component---src-pages-elements-button-js","37":"component---src-pages-elements-call-to-action-js","38":"component---src-pages-elements-client-logo-js","39":"component---src-pages-elements-counters-js","40":"component---src-pages-elements-dividers-js","41":"component---src-pages-elements-flexible-image-slider-js","42":"component---src-pages-elements-google-map-js","43":"component---src-pages-elements-gradation-js","44":"component---src-pages-elements-lists-js","45":"component---src-pages-elements-message-box-js","46":"component---src-pages-elements-popup-video-js","47":"component---src-pages-elements-pricing-box-js","48":"component---src-pages-elements-progress-bar-js","49":"component---src-pages-elements-progress-circle-js","50":"component---src-pages-elements-social-networks-js","51":"component---src-pages-elements-tabs-js","52":"component---src-pages-elements-team-member-js","53":"component---src-pages-elements-testimonials-js","54":"component---src-pages-elements-timeline-js","55":"component---src-pages-elements-typed-text-js","56":"component---src-pages-index-js","57":"component---src-pages-mobileapps-js","58":"component---src-pages-webapps-js","59":"component---src-templates-author-template-author-template-js","60":"component---src-templates-blog-list-blog-list-js","61":"component---src-templates-blog-template-blog-template-js","62":"component---src-templates-case-study-template-case-study-template-js","63":"component---src-templates-category-template-category-template-js","64":"component---src-templates-date-template-date-template-js","65":"component---src-templates-it-solution-template-it-solution-template-js","66":"component---src-templates-search-template-search-template-js","67":"component---src-templates-service-template-service-template-js","68":"component---src-templates-tag-template-tag-template-js"}[chunkId]||chunkId) + "-" + {"0":"0d1cf51b2cc2c7988dd1","1":"4bbcb17c8c05ac08ae5d","2":"be4ebae3fe6dcfdf2aeb","3":"de92bd001709a43adaea","4":"2ea21bb6e334353b9089","5":"c30e35a4dbe1caa79c1b","6":"fdc0735c32d9b5c60b20","7":"d45985cc23d09e300a5b","8":"3f7d93ccfb4b91568654","9":"255d938c7333b519a091","10":"8c545130c73889545e4a","11":"8b9d5d5a3f102f7c4204","12":"06eefdd6de6ec9deab7d","13":"8e5e968cb19df017a34c","14":"94b4d36f43f99a42b12e","15":"4742159f2af70d2ad98f","16":"5fa79514f028c6ad8cea","17":"d3af643463415dd58459","18":"c27c92cae414386fbcc6","19":"cca74affdf18f56fc969","22":"384f7ed9f3a0c2f4c2ec","24":"6e2b4e001bd8bbe51854","25":"73a6c4144d3fad51d702","26":"79362d717c5090be57c7","27":"a1ed2468459ace244033","28":"143b651cab2a969aba2b","29":"e56f0aedb66efa00d498","30":"a9d591bf620f0cc852fd","31":"edd7cfc6446e5b9f9984","32":"883b94abf1914d87f87c","33":"f717acffe0cba3fa3943","34":"6091c957d16660acf16a","35":"29ff552ab107e5143295","36":"a0edc1e02ee2783b2895","37":"09ccd7ce9f634ca56e7c","38":"907429c90ea7aba4ca72","39":"e68754f2db80f2007bb6","40":"039298c2ddc073357134","41":"513d3a624cff038d54c6","42":"b692ce6b017acafdae40","43":"59b5dc3aa00bfb0f446c","44":"08c99b5cf424fd8f5f0a","45":"21a5e5094c0f765b200d","46":"2de0911da89f178163b3","47":"e10e96447611dc727f0a","48":"6d977a8000204191cd4b","49":"1166953608573d0fc974","50":"73c66e6b408d0dc51fcd","51":"2d7aa4836a71f681c859","52":"5256b3d28d03e26c0c23","53":"86285648b16ff44c980c","54":"e80a848ab3bac077f3c6","55":"725fe8e21aa50498288c","56":"6d30f47448fc14fc701c","57":"484787e81e91b42fa9a2","58":"0db1fa123579e0a1b8e6","59":"de90f54b53cf14d960ba","60":"d234f8c16963c80406dc","61":"3eb2d1618464b4091d05","62":"5bf7cfca268afc7f5eaf","63":"ab0729d2580a3de463e2","64":"10678673736ab711ac47","65":"57035fba7036dc5df65d","66":"9e215ad42b27d1653001","67":"529098e6d9398c3b7bda","68":"f381b8d8886e3ce8ac1d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"6e9765af0d8cadc878f9f8c2310a458594d6236c","1":"3535c12f2676d7d818bc3663a5d68b8cdaf57932","2":"de71a805","3":"1bfc9850","4":"e13c3f781831cf288a166224be59f9e900beb1eb","5":"7261c7a5008f72e8df93cca2226e5795336d06c6","6":"styles","7":"0b88e34b4cfcb3cef2b98900384b5bced6ad52cf","8":"c5dfd7d200e7f3593e8384acc111a781d580d7e0","9":"c21f3e3758b538213289b51509a631e3a51d21f3","10":"fadb1fcec6cad6cacf534cb5e8a7a44a2c4254a0","11":"5e2a4920","12":"a4c92b5b","13":"c12974d03ffdc601d101aab1c7f05ad2f6d58131","14":"e5a5014b076735dc5398446ae7003bffb5485bb0","15":"a48987767876a59d3057dc923b8b92fef19b97b4","16":"e2795cd79bdc65c94c741a4388b83e68c3033fab","17":"1b404b28ab79dc07c3b6f61c1d07ff237951e496","18":"1ca2f4d91de47e91be63b0c64ca93d14f0cceb14","19":"e52995f9af5ad4a238f3249a061497eb8d65e61e","22":"95b64a6e","24":"component---cache-caches-gatsby-plugin-offline-app-shell-js","25":"component---src-pages-404-js","26":"component---src-pages-about-us-js","27":"component---src-pages-analytics-js","28":"component---src-pages-blockchain-js","29":"component---src-pages-cloud-js","30":"component---src-pages-contact-us-js","31":"component---src-pages-digital-transformation-js","32":"component---src-pages-elements-accordion-js","33":"component---src-pages-elements-box-icon-js","34":"component---src-pages-elements-box-image-js","35":"component---src-pages-elements-box-large-image-js","36":"component---src-pages-elements-button-js","37":"component---src-pages-elements-call-to-action-js","38":"component---src-pages-elements-client-logo-js","39":"component---src-pages-elements-counters-js","40":"component---src-pages-elements-dividers-js","41":"component---src-pages-elements-flexible-image-slider-js","42":"component---src-pages-elements-google-map-js","43":"component---src-pages-elements-gradation-js","44":"component---src-pages-elements-lists-js","45":"component---src-pages-elements-message-box-js","46":"component---src-pages-elements-popup-video-js","47":"component---src-pages-elements-pricing-box-js","48":"component---src-pages-elements-progress-bar-js","49":"component---src-pages-elements-progress-circle-js","50":"component---src-pages-elements-social-networks-js","51":"component---src-pages-elements-tabs-js","52":"component---src-pages-elements-team-member-js","53":"component---src-pages-elements-testimonials-js","54":"component---src-pages-elements-timeline-js","55":"component---src-pages-elements-typed-text-js","56":"component---src-pages-index-js","57":"component---src-pages-mobileapps-js","58":"component---src-pages-webapps-js","59":"component---src-templates-author-template-author-template-js","60":"component---src-templates-blog-list-blog-list-js","61":"component---src-templates-blog-template-blog-template-js","62":"component---src-templates-case-study-template-case-study-template-js","63":"component---src-templates-category-template-category-template-js","64":"component---src-templates-date-template-date-template-js","65":"component---src-templates-it-solution-template-it-solution-template-js","66":"component---src-templates-search-template-search-template-js","67":"component---src-templates-service-template-service-template-js","68":"component---src-templates-tag-template-tag-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"13b7654744177221dec4","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
